import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactSlider from "react-slider";
import { useSearchParams } from "react-router-dom";
import { errorAlert, successAlert } from "../apiService/sweetAlert";
import {
  addToGuestCart,
  dispatchCartUpdate,
  isLoggedIn,
} from "../helper/cartUtils";
import { apiRequest } from "../apiService/allapi";
const ShopSection = () => {
  const [searchParams] = useSearchParams();
  let [grid, setGrid] = useState(false);

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setsubCategories] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [wishlistProducts, setWishlistProducts] = useState(new Set()); // 🔥 Track by product ID
  // Function to call all 3 APIs at once when page loads
  const getInitialData = async () => {
    try {
      setLoading(true);

      const urlCategory = searchParams.get("category");

      // First API: Get all categories
      const categoriesRes = await apiRequest("/Category/category/list", "GET");

      let catData = categoriesRes?.data?.data || categoriesRes?.data;

      if (Array.isArray(catData)) {
        setCategories(catData);

        if (
          urlCategory &&
          catData.some((cat) => (cat.id || cat._id) == urlCategory)
        ) {
          // URL category found, auto-select it
          await handleCategoryClick(urlCategory);
          return;
        }

        if (catData.length > 0) {
          const firstCatId = catData[0].id;
          setCategoryId(firstCatId);

          // Second API: Get sub-categories
          const subCatRes = await apiRequest(
            `/Category/subcategory/list/${firstCatId}`,
            "GET",
          );

          let subCatData = subCatRes?.data?.data || subCatRes?.data;

          if (Array.isArray(subCatData)) {
            setsubCategories(subCatData);

            if (subCatData.length > 0) {
              const firstSubCatId = subCatData[0].id;
              setSelectedSubCategory(firstSubCatId);

              // ✅ Product load
              await getProductsBySubCategory(firstCatId, firstSubCatId);
            }
          }
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  // 🔥 Load wishlist on mount
  useEffect(() => {
    getWishlistItems();
  }, []);

  // Handle category click - load sub and sub-sub categories
  const handleCategoryClick = async (catId) => {
    try {
      setLoading(true);
      setCategoryId(catId);

      const subCatRes = await apiRequest(
        `/Category/subcategory/list/${catId}`,
        "GET",
      );

      if (subCatRes?.data?.status === 1) {
        const subCatData = subCatRes.data.data;

        setsubCategories(subCatData);
        setSelectedSubCategory(null);
        setProducts([]); // ✅ purane products clear

        if (subCatData && subCatData.length > 0) {
          const firstSubCatId = subCatData[0].id;
          setSelectedSubCategory(firstSubCatId);

          // ✅ await use karo
          await getProductsBySubCategory(catId, firstSubCatId);
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle sub-category click - load sub-sub categories
  const handleSubCategoryClick = (subId) => {
    setSelectedSubCategory(subId);
    getProductsBySubCategory(categoryId, subId);
  };
  const getProductsBySubCategory = async (catId, subId) => {
    try {
      const res = await apiRequest(
        `/Product/product/list/${catId}/${subId}`,
        "GET",
      );

      const data = res?.data?.data || res?.data;

      if (Array.isArray(data)) {
        setProducts(data);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.log("Product Error:", error);
      setProducts([]);
    }
  };
  // ADD TO CART
  const addToCart = async (product) => {
    const token = localStorage.getItem("token");

    const pid = product.id;
    const availableStock = product.stock || product.stockQty || 999;

    // 🟡 Guest user
    if (!token) {
      const cart = JSON.parse(localStorage.getItem("guestCart")) || [];

      const existingItem = cart.find((item) => item.pid === pid);
      const existingQty = existingItem ? existingItem.qty : 0;

      if (existingQty + 1 > availableStock) {
        errorAlert("Out of Stock");
        return;
      }

      const guestItem = {
        pid: product.id,
        productName: product.productName,
        sellingPrice: product.sellingPrice,
        imG1: product.imgurl,
        qty: 1,
      };

      addToGuestCart(guestItem);
      successAlert("Product added to cart");

      dispatchCartUpdate();
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      return;
    }

    // 🟢 Logged-in user
    try {
      const res = await apiRequest(
        "/Cart/add-to-cart",
        "POST",
        {
          pid: product.id,
          qty: 1,
        },
        {
          Authorization: `Bearer ${token}`,
        },
      );

      if (res?.data?.status === true) {
        successAlert("Product added to cart");

        dispatchCartUpdate();
        window.dispatchEvent(new CustomEvent("cartUpdated"));
      } else {
        errorAlert(res.data.message);
      }
    } catch (error) {
      console.log(error);
      errorAlert("Failed to add to cart");
    }
  };

  const addToWishlist = async (pid) => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest(
        "/Wishlist/AddToggleWishlist",
        "POST",
        { productId: pid },
        { Authorization: `Bearer ${token}` },
      );

      if (res?.data?.success === true || res?.data?.status === true) {
        successAlert(res.data.message);
        window.dispatchEvent(new Event("wishlistUpdated"));

        setWishlistProducts((prev) => {
          const updated = new Set(prev);

          if (updated.has(pid)) {
            updated.delete(pid); // remove
          } else {
            updated.add(pid); // add
          }

          return updated;
        });
      } else {
        errorAlert(res?.data?.message || "Failed");
      }
    } catch (error) {
      console.log("Wishlist Error:", error);
      errorAlert("Something went wrong");
    }
  };

  // 🔥 NEW: Load initial wishlist from server
  const getWishlistItems = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return; // Guest: empty wishlist

      const res = await apiRequest("/Wishlist/getToggle", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        const wishlistPids = new Set(
          (res.data.data || []).map((item) => item.pid),
        );
        setWishlistProducts(wishlistPids);
      }
    } catch (error) {
      console.log("Load wishlist error:", error);
    }
  };
  return (
    <section className="shop py-80">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${active && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <i className="ph ph-x" />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  All Category
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  {categories &&
                    categories.map((cat, index) => (
                      <li className="mb-24" key={index}>
                        <button
                          onClick={() => {
                            const newUrl = new URLSearchParams(
                              searchParams.toString(),
                            );
                            newUrl.set("category", cat.id);
                            window.history.replaceState(
                              null,
                              "",
                              `?${newUrl.toString()}`,
                            );
                            handleCategoryClick(cat.id);
                          }}
                          className={`text-gray-900 hover-text-main-600 bg-transparent border-0 p-0 text-start d-flex align-items-center gap-2 ${categoryId === cat.id ? "text-main-600 fw-bold" : ""}`}
                          style={{ cursor: "pointer" }}
                        >
                          {cat.name}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
              {/* <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Price
                </h6>
                <div className="custom--range">
                  <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    defaultValue={[0, 100]}
                    ariaLabel={["Lower thumb", "Upper thumb"]}
                    ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
                    renderThumb={(props, state) => {
                      const { key, ...restProps } = props;
                      return (
                        <div {...restProps} key={state.index}>
                          {state.valueNow}
                        </div>
                      );
                    }}
                    pearling
                    minDistance={10}
                  />

                  <br />
                  <br />
                  <div className="flex-between flex-wrap-reverse gap-8 mt-24 ">
                    <button
                      type="button"
                      className="btn btn-main h-40 flex-align"
                    >
                      Filter{" "}
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          {/* Sidebar End */}
          {/* Content Start */}
          <div className="col-lg-9">
            {/* Top Start */}
            <div className="flex-between gap-16 flex-wrap mb-40">
              <button
                onClick={sidebarController}
                type="button"
                className="btn btn-main d-lg-none rounded-pill px-24 py-10"
              >
                <i className="ph ph-funnel me-6" />
                Categories
              </button>
            </div>
            {/* Top End */}

            {/* Loading Indicator */}
            {loading && (
              <div className="text-center mb-30">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            {/* Sub Categories Display - Right Side */}
            {!loading && subCategories?.length > 0 && (
              <div className="mb-30">
                <h5 className="mb-20">Sub Categories</h5>
                <div className="row">
                  {subCategories.map((sub) => (
                    <div className="col-md-3 mb-3" key={sub.id}>
                      <Link
                        to="#"
                        onClick={() => handleSubCategoryClick(sub.id)}
                        className={`border p-3 text-center d-block rounded text-gray-900 hover-text-main-600 ${selectedSubCategory === sub.id ? "border-main-600 bg-light" : ""}`}
                        style={{ textDecoration: "none" }}
                      >
                        {sub.imagePath && (
                          <img
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${sub.imagePath}`}
                            className="w-100 mb-2 rounded"
                            style={{ height: "100px", objectFit: "cover" }}
                          />
                        )}
                        <span className="d-block">{sub.name}</span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Sub-Sub Categories Display - Below Sub Categories with Images */}

            {/* ✅ YAHAN PASTE KARO */}
            {!loading && (
              <div className="mt-40">
                <h5 className="mb-20">Products</h5>

                {products.length === 0 ? (
                  <p className="text-center">No Products Found</p>
                ) : (
                  <div className={`list-grid-wrapper ${grid && "list-view"}`}>
                    {products.map((product) => (
                      <div
                        key={product.id}
                        className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2"
                      >
                        {/* ❤️ Wishlist Icon */}
                        {isLoggedIn() && (
                          <button
                            onClick={() => addToWishlist(product.id)}
                            className="wishlist-btn position-absolute top-0 end-0 m-12 rounded-circle flex-center"
                            style={{
                              width: "40px",
                              height: "40px",
                              border: "none",
                              zIndex: 10,
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill={
                                wishlistProducts.has(product.id)
                                  ? "#ef4444"
                                  : "none"
                              }
                              stroke={
                                wishlistProducts.has(product.id)
                                  ? "#ef4444"
                                  : "currentColor"
                              }
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-heart transition-colors duration-200"
                            >
                              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                            </svg>
                          </button>
                        )}
                        <Link
                          to={`/product-details/${product.id}`}
                          className="product-card__thumb flex-center rounded-8  position-relative"
                        >
                          <img
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${product.imgurl}`}
                            alt={product.productName}
                            className="max-w-[120px]"
                          />
                        </Link>

                        <div className="product-card__content mt-16">
                          <h6 className="title text-lg fw-semibold mt-12 mb-8">
                            <Link
                              to={`/product-details/${product.id}`}
                              className="link text-line-2"
                            >
                              {product.productName}
                            </Link>
                          </h6>

                          <div className="flex-align mb-20 mt-16 gap-6">
                            <span className="text-xs fw-medium text-gray-500">
                              {product.ratingAverage || 0}
                            </span>
                            <span className="text-15 fw-medium text-warning-600 d-flex">
                              <i className="ph-fill ph-star" />
                            </span>
                            <span className="text-xs fw-medium text-gray-500">
                              ({product.totalRating || 0})
                            </span>
                          </div>

                          <div className="product-card__price my-20">
                            <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                              ₹{Number(product.mrp).toFixed(2)}
                            </span>
                            <span className="text-heading text-md fw-semibold">
                              ₹{Number(product.sellingPrice).toFixed(2)}
                            </span>
                          </div>

                          {product.isStock ? (
                            <button
                              onClick={() => addToCart(product)}
                              className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                            >
                              Add To Cart <i className="ph ph-shopping-cart" />
                            </button>
                          ) : (
                            <span className="text-danger fw-medium">
                              Out of Stock
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {/* Pagination Start */}
            {/* <ul className="pagination flex-center flex-wrap gap-16">
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  <i className="ph-bold ph-arrow-left" />
                </Link>
              </li>
              <li className="page-item active">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  01
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  02
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  03
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  04
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  05
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  06
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  07
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                  to="#"
                >
                  <i className="ph-bold ph-arrow-right" />
                </Link>
              </li>
            </ul> */}
            {/* Pagination End */}
          </div>
          {/* Content End */}
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
